<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Número do conselho</th>
          <th>Especialidades</th>
          <th>Unidades</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="profissional in profissionais" :key="profissional._id">
          <td>{{ profissional.nome }}</td>
          <td>{{ profissional.numeroConselho }}</td>
          <td>
            <button
              data-test-id="button-exibiralertavaloressimples-1"
              class="btn btn-xs btn-link"
              @click="
                exibirAlertaValoresSimples(
                  'Especialidades',
                  profissional.especialidade
                )
              "
            >
              Ver especialidades
            </button>
          </td>
          <td>
            <button
              data-test-id="button-exibiralertavaloressimples-2"
              class="btn btn-xs btn-link"
              @click="
                exibirAlertaValoresSimples('Unidades', profissional.unidade)
              "
            >
              Ver unidades
            </button>
          </td>
          <td>
            <RouterLink
              v-tooltip="'Editar profissional'"
              data-test-id="link-auto-3"
              :to="'/profissional/cadastro/' + profissional._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
            <RouterLink
              v-tooltip="'Ver agendamentos'"
              data-test-id="link-auto-4"
              :to="'/profissional/' + profissional._id + '/agendamentos'"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-calendar" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'

export default {
  name: 'ProfissionalTabela',
  mixins: [alertaMixin],
  props: {
    profissionais: {
      type: Array,
      required: true,
    },
  },
}
</script>
